angular.module('com.vmware.vsphere.client.vm').factory('VirtualMachineDevices', [
   'vmDeviceInfoService',
   'virtualDeviceInflator',
   function (vmDeviceInfoService, virtualDeviceInflator) {
      var VirtualMachineDevices = function VirtualMachineDevices(
         rawDevices,
         profileAssignments,
         profiles,
         availableNetworks,
         deviceOptionsByDeviceType,
         isScheduledTask
      ) {
         var self = this;
         var additionalInfo = {
            storageProfiles: profiles,
            storageProfileAssignments: profileAssignments,
            availableNetworks: availableNetworks,
            deviceOptionsByDeviceType: deviceOptionsByDeviceType,
            isScheduledTask: isScheduledTask
         };
         var deviceList = virtualDeviceInflator.inflateDevices(rawDevices, additionalInfo);
         var inflatedDevices = _.reduce(deviceList, function(memo, virtualDevice) {
            memo[virtualDevice.getKey()] = virtualDevice;
            return memo;
         }, {});

         var rgValidationCallbacks = {};

         this.addRgValidationCallback = function(deviceKey, callback) {
            rgValidationCallbacks[deviceKey] = callback;
         };

         this.notifyRgValidationCallbacks = function() {
            var deviceKeys = Object.keys(rgValidationCallbacks);
            deviceKeys.forEach(function(deviceKey){
               if (rgValidationCallbacks[deviceKey]) {
                  rgValidationCallbacks[deviceKey]();
               }
            });
         };

         this.getDeviceChanges = function() {
            var array = _.chain(this.getInflatedDevices())
               .filter(function(inflatedDevice) {
                  return inflatedDevice.hasChanged();
               })
               .map(function(changedDevice) {
                  return changedDevice.getCurrentDeviceSpec();
               })
               .value();
            return array;
         };

         this.getFinalChanges = function() {
            var array = _.chain(this.getInflatedDevices())
               .filter(function(inflatedDevice) {
                  return inflatedDevice.hasChanged();
               })
               .map(function(changedDevice) {
                  return changedDevice.getFinalDeviceSpec();
               })
               .value();
            return array;
         };

         this.findDeviceSpec = function(deviceKey) {
            var virtualDevice = _.find(inflatedDevices, function(device) {
               return device.getKey() === deviceKey;
            });

            return virtualDevice && virtualDevice.getCurrentDeviceSpec();
         };

         this.getInflatedDevices = function() {
            return _.values(inflatedDevices);
         };

         this.getDeviceSpecForDevice = function(device) {
            var virtualDevice = inflatedDevices[device.key];
            if (!virtualDevice) {
               virtualDevice = virtualDeviceInflator.inflate(device);
               inflatedDevices[device.key] = virtualDevice;
            }

            return virtualDevice.getCurrentDeviceSpec();
         };

         this.devicesOfType = function (deviceType) {
            return _.filter(inflatedDevices, function (virtualDevice) {
               return virtualDevice.isOfType(deviceType);
            });
         };

         this.devicesOfTypeNotMarkedForRemoval = function (deviceType) {
            return _.filter(inflatedDevices, function (virtualDevice) {
               return virtualDevice.isOfType(deviceType)
                     && !virtualDevice.isMarkedForRemoval();
            });
         };

         // Presenter method that could be moved to its own service
         this.existingDevicesOfType = function(deviceType) {
            return _.filter(this.devicesOfType(deviceType), function (virtualDevice) {
               return !virtualDevice.isNew();
            });
         };

         this.existingSortedDevicesOfType = function(deviceType) {
            var existingDevicesOfType = _.filter(this.devicesOfType(deviceType), function (virtualDevice) {
               return !virtualDevice.isNew();
            });

            existingDevicesOfType.sort(function(a, b) {
               // match only numbers, then convert to true integers
               var diskNumberA = parseInt(a.deviceName().match(/\d+/g)[0], 10);
               var diskNumberB = parseInt(b.deviceName().match(/\d+/g)[0], 10);

               return diskNumberA - diskNumberB;
            });

            return existingDevicesOfType;
         };

         // Presenter method that could be moved to its own service
         this.newDevicesOfType = function (deviceType) {
            return _.filter(this.devicesOfType(deviceType), function (virtualDevice) {
               return virtualDevice.isNew();
            });
         };

         // Presenter method that could be moved to its own service
         this.findDevicesOfType = function (deviceType) {
            return this.devicesOfType(deviceType);
         };

         this.changedDevicesOfType = function (deviceType) {
            return _.filter(this.devicesOfType(deviceType), function (virtualDevice) {
               return virtualDevice.hasChanged();
            });
         };

         this.removeDeviceByKey = function(deviceKey) {
            var virtualDevice = this.getVirtualDevice(deviceKey);
            if(virtualDevice.isNew()) {
               delete inflatedDevices[deviceKey];
               delete rgValidationCallbacks[deviceKey];
            } else {
               virtualDevice.markForRemoval();
            }
         };

         this.getAllDevicesNotMarkedForRemoval = function () {
            return _.filter(self.getInflatedDevices(), function(device) {
               return !device.isMarkedForRemoval();
            });
         };

         this.getDevicesThatHaveBeenAssignedToNodes = function () {
            return _.chain(this.getAllDevicesNotMarkedForRemoval())
               .filter(function(device){
                  return _.isNumber(device.getCurrentDevice().unitNumber);
               })
               .sortBy(function(device) {
                  return device.hasChanged() ? 1 : -1;
               })
               .map(function(device){
                  return device.getCurrentDevice();
               })
               .value();
         };

         this.getDevicesAttachedToControllerKey = function (controllerKey) {
            var assignedDevices = self.getDevicesThatHaveBeenAssignedToNodes();
            return _.filter(assignedDevices, function(device) {
               return device.controllerKey === controllerKey;
            });
         };

         this.getRdmDisksNotMarkedForRemoval = function() {
            return _.chain(this.getAllDevicesNotMarkedForRemoval())
               .filter(function(inflatedDevice) {
                  return _.isFunction(inflatedDevice.isRDMDisk) && inflatedDevice.isRDMDisk();
               })
               .map(function(inflatedDevice) {
                  return inflatedDevice.getCurrentDevice();
               })
               .value();
         };

         this.isNodeInUse = function (controllerKey, nodeUnitNumber) {
            var devicesNotMarkedForRemoval = self.getAllDevicesNotMarkedForRemoval();
            return _.any(devicesNotMarkedForRemoval, function(virtualDevice){
               return virtualDevice.getCurrentDevice().controllerKey === controllerKey
                  && virtualDevice.getCurrentDevice().unitNumber === nodeUnitNumber;
            });
         };

         this.getVirtualDevice = function(deviceKey){
            return inflatedDevices[deviceKey];
         };

         this.addVirtualDevice = function(virtualDevice) {
            var deviceKey = virtualDevice.getKey();
            if(self.getVirtualDevice(deviceKey)) {
               throw(new Error('VirtualDevice already exists for key ' + deviceKey + ":" + _.keys(inflatedDevices)));
            }
            inflatedDevices[deviceKey] = virtualDevice;
         };

         this.devicesMarkedForRemovalOfType = function(deviceType) {
            return _.filter(self.getInflatedDevices(), function(device) {
               return device.isMarkedForRemoval() && device.isOfType(deviceType);
            });
         };

         this.devicesNotMarkedForRemovalOfType = function(deviceType) {
            return _.filter(self.getInflatedDevices(), function(device) {
               return !device.isMarkedForRemoval() && device.isOfType(deviceType);
            });
         };
      };

      return VirtualMachineDevices;
   }
]);
